<template>
  <el-button
    :type="type"
    :plain="plain"
    :disabled="disabled"
    :size="size"
    :icon="icon"
    :circle="circle"
    :style="styles"
    :native-type="nativeType"
    @click="clickHandle"
    :class="file ? 'filebtn' : ''"
  >
    {{ text }}
    <input 
			v-if="file" 
			type="file" 
      :multiple="multiple"
			@change="fileChange"
			ref="file"
		/>
  </el-button>
</template>
<style scoped>
</style>
<script>
import { button } from "element-ui";
export default {
  name: "buttonBox",
  props: {
    plain: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      // default:'按钮'
    },
    type: {
      type: String,
      default: "primary",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
    },
    icon: {
      type: String,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    styles: {
      type: [Object, String],
    },
    nativeType: {
      type: String,
      default: "button",
    },
    file: {
      type: Boolean,
      default: false,
    },
    multiple:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    clickHandle() {
      this.$emit("click");
    },
		fileChange(){
			let files = this.$refs.file.files;
			this.$emit('fileChange',files);
		}
  },
  components: {
    elButton: button,
  },
};
</script>
<style scoped>
.filebtn {
  position: relative;
}
.filebtn input {
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  opacity: 0;
}
</style>
<style>
.el-button--primary{
  max-height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/buttonBox.vue